import { TaxClassification } from '@vgrubs/components';
import { AccountType, Step } from '../../hooks/useWalletV2';

export const handleTitle = (step: Step): string => {
  switch (step) {
    case Step.AboutYou:
      return 'About You';
    case Step.BusinessInfo:
      return 'Business Info';
    case Step.BankInfo:
      return 'Bank Info';
    case Step.Confirmation:
      return 'Confirmation';
    default:
      return 'Add Bank';
  }
};

export const handleSubtitle = (
  step: Step,
  accountType: AccountType
): string => {
  if (accountType === AccountType.individual) {
    switch (step) {
      case Step.AboutYou:
        return 'Step 1/3';
      case Step.BankInfo:
        return 'Step 2/3';
      case Step.Confirmation:
        return 'Step 3/3';
    }
  } else {
    switch (step) {
      case Step.AboutYou:
        return 'Step 1/4';
      case Step.BusinessInfo:
        return 'Step 2/4';
      case Step.BankInfo:
        return 'Step 3/4';
      case Step.Confirmation:
        return 'Step 4/4';
    }
  }
  return '';
};

export const handleNextButtonText = (step: Step): string => {
  switch (step) {
    case Step.Confirmation:
      return 'Connect Bank Account';
    default:
      return 'Next';
  }
};

export const renderAccountType = (taxClassification: TaxClassification) => {
  switch (taxClassification) {
    case TaxClassification.individual:
      return 'Personal';
    case TaxClassification.soleProprietor:
      return 'Sole Proprietor';
    case TaxClassification.singleMemberLlc:
      return 'LLC / Single Member';
    case TaxClassification.llcPartnership:
      return 'LLC / Partnership';
    case TaxClassification.llcCCorporation:
      return 'LLC / C-Corporation';
    case TaxClassification.llcSCorporation:
      return 'LLC / S-Corporation';
    case TaxClassification.cCorporation:
      return 'Corporation / C-Corp';
    case TaxClassification.sCorporation:
      return 'Corporation / S-Corp';
    case TaxClassification.partnership:
      return 'Partnership';
    case TaxClassification.trust:
      return 'Trust';
    case TaxClassification.estate:
      return 'Estate';
    default:
      return '';
  }
};
